import React, {Component} from 'react';

import services from './../../services';

import layouts from './../../layouts';
import Modal from './../Modal';
import Grid from './../Grid';
import Submit from './../Submit';

import { Modal as antdModal } from 'antd';
import components from './../../components';
import Input from './../../components/Input';

export default class extends Component {
    constructor(props) {
        super(props);

        this.state = {
            keywords: {
            },
            domain: {
            }
        };

        this.domain = {};

        services.graduation.master.onSelect([]);
    }

    componentWillReceiveProps(nextProps) {
        const roleId = nextProps.roleId;
        const role = nextProps.role
        this.setState({
            keywords: {
                // roleId,
                v: Math.random(),
                pageNum: 1,
                orgId: '', 
                classesId: '', 
                classesName: '',
                studentNo: ''
            },
            domain: {
                roleId,
                role
            }
        })
    }

    handleSubmit() {
        // this.handleCancel();
        const userIds = services.graduation.master.getSelection();
        const data = Object.assign({}, this.state.domain, {userIds: userIds});
        services.roles.saveRoleMaster(data).then(d => {
            this.handleCancel();
        });
    }

    handleChange(data) {
        //this.domain = Object.assign({}, this.domain, data);
        this.setState({
            keywords: Object.assign({}, this.state.keywords, data)
        });
    }

    handleSearchSubmit() {
        this.setState({
            keywords: Object.assign({}, this.state.keywords, this.domain, {
                v: Date.now(),
                pageNum: 1
            })
        });
    }
    
    handleCancel() {
        this.props.handleCancel();
        this.setState({
            keywords: {v: Date.now(), visible: this.props.visible, orgId: '', classesId: '',classesName:'', studentNo: ''},
        })
    }

    render() {
        return (
            <Modal title="添加组成员" visible={this.props.visible}  handleSubmit={this.handleSubmit.bind(this)} handleCancel={this.handleCancel.bind(this)}>
                <layouts.Search onSubmit={this.handleSearchSubmit.bind(this)}>
                    <div>
                        <div className="search-item">
                            <components.org.Name type="all" value={this.state.keywords.orgName} style={{width: 160}} handleChange={this.handleChange.bind(this)} />
                            
                            <Input label="专家名字" style={{width: 160}} name={'realName'} handleChange={this.handleChange.bind(this)}></Input>      

                            <Input label="用户名" style={{width: 160}} name={'loginName'} handleChange={this.handleChange.bind(this)}></Input>      

                            <Submit>检索</Submit>
                        </div>
                        {/* <div className="search-item">
                            <components.student.StudentNo value={this.state.keywords.studentNo} style={{width: 160}} handleChange={this.handleChange.bind(this)} />
                            <components.student.Name value={this.state.keywords.name} style={{width: 160}} handleChange={this.handleChange.bind(this)} />                            
                        </div> */}
                    </div>
                </layouts.Search>
                <Grid ismodal="true" keywords={this.state.keywords} service={services.graduation.master}/>
            </Modal>
        )
    }
}